import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";
import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';
import logo from '../../../assets/atsPious/logo (1).jpg'
import ImageSwiper from '../../common/ImageSwiper';

const imgUrl = process.env.REACT_APP_IMAGEURL

const ATS = () => {
    // const logo = `${imgUrl}/atshomekraft/logo.jpg`;
    const hero1 = `${imgUrl}/atshomekraft/hero-1.jpg`;
    const hero2 = `${imgUrl}/atshomekraft/hero-2.jpg`;
    const hero3 = `${imgUrl}/atshomekraft/hero-3.jpg`;
    const hero4 = `${imgUrl}/atshomekraft/hero-4.jpg`;
    const hero5 = `${imgUrl}/atshomekraft/hero-5.jpg`;

    const ph1 = `${imgUrl}/atshomekraft/ph-1.webp`;
    const ph2 = `${imgUrl}/atshomekraft/ph-2.webp`;
    const ph3 = `${imgUrl}/atshomekraft/ph-3.webp`;
    const ph4 = `${imgUrl}/atshomekraft/ph-4.webp`;
    const ph5 = `${imgUrl}/atshomekraft/ph-5.webp`;

    const li1 = `${imgUrl}/atshomekraft/li-1.jpg`;
    const li2 = `${imgUrl}/atshomekraft/li-2.jpg`;
    const li3 = `${imgUrl}/atshomekraft/li-3.jpg`;
    const li4 = `${imgUrl}/atshomekraft/li-4.jpg`;
    const li5 = `${imgUrl}/atshomekraft/li-5.jpg`;

    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);

    const images = [hero1, hero2, hero3, hero4, hero5];
    const ameneties = [ph1, ph2, ph3, ph4, ph5]
    const interiors = [li1, li2, li3, li4, li5]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    };

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <ImageSwiper images={images}/>
            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="relative w-full sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] aspect-[16/9] overflow-hidden rounded-lg">
                    <img
                        src={logo}
                        alt="logo"
                        className="absolute top-0 left-0 w-full h-full object-cover"
                    />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Imagine waking up to lush green landscapes, breathing fresh air, and living in a gated, luxurious community that offers peace, security, and world-class amenities,
                                all while staying connected to Delhi, Noida, and NCR.Sounds like a dream? Well, ATS Homekraft is turning this dream into reality with its new luxury plotted development in Sector 22D, Greater Noida, on the Yamuna Expressway.
                            </p>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                This isn’t just a real estate project - it’s an opportunity to build your dream home in a premium location that guarantees high appreciation and top-notch lifestyle benefits.
                            </p>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Prime Location with Unbeatable Connectivity:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Location is everything! Situated right on Yamuna Expressway, this project offers:
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Quick access to Noida, Greater Noida, and Delhi NCR
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Proximity to Jewar International Airport – a future game-changer
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Close to Noida Film City, IT hubs, and educational institutions
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Near upcoming metro stations & business districts
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">
                                        Your Vision, Your Land – The Perfect Plot is Here:
                                    </h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        This isn’t just land - it’s your canvas to design the perfect home. Whether you want a modern villa, a duplex, or a stylish bungalow, these spacious residential plots (starting from 150 sq. yards and above) give you complete flexibility.                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Wide-open spaces for an airy, green environment
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Well-planned infrastructure with paved roads & streetlights
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            High-end community living with 24x7 security
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">
                                        Live, Play, Relax – Everything You Need in One Place:
                                    </h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Living here means enjoying life to the fullest. You don’t just get land, you get a complete lifestyle upgrade.
                                    </p>

                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Swimming Pool & Clubhouse – Unwind in style
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Sports Facilities – Tennis courts, cricket fields & jogging tracks
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Kids’ Play Areas – Safe & fun spaces for children
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Green Parks & Hidden Pathways – Perfect for morning walks
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            24/7 Power & Water Supply – Hassle-free living
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Advanced Security System – CCTV, guards & gated access
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">
                                        A Smart Investment with High Returns:
                                    </h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Real estate in Noida is booming, and ATS Homekraft’s plots on Yamuna Expressway are in one of the fastest-growing locations.
                                        Property prices in Greater Noida are rising fast - get in early!                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Jewar Airport & Film City will boost demand for real estate investments                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            A secure, gated community with modern infrastructure = high ROI.
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Ideal for self-use or rental income - these plots are in high demand.
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">
                                        Your Dream Plot is Waiting – Claim It Now:
                                    </h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Opportunities like this don’t come twice! Own a premium plot in Noida’s top real estate hotspot and build the life you’ve always wanted. Whether you're a homebuyer or an investor, ATS Homekraft’s luxury plotted development offers security, comfort, and high returns.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 m-4">
                Projects Highlights
            </h2>
            {openImgModal && activeImageType === "ameneties" && (
                <ImageModal
                    images={ameneties}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 px-4">
                {ameneties.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index, "ameneties")}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img
                            src={data}
                            alt="ATS"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>

            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                    Luxury  Insights
                </h2>

                {openImgModal && activeImageType === "interiors" && (
                    <ImageModal
                        images={interiors}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {interiors.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "interiors")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}
export default ATS